// TODO: remove with https://github.com/combinaut/sparkle/issues/32203 once visual-form editing renders through an sp app.
/**
 * Builds select items from visual-form preview options, in the shape `Admin::SpSelect::ItemsBuilder` renders
 * on the server: string values, camel-cased string datasets, `data-subtext` as the subtitle, and nested children under a `hasChildren` parent.
 * `spec/fixtures/files/sp_select/visual_form_items.json` holds the cases both builders must agree on.
 */
export function visualFormSelectItems(options, { includeBlank = false, nested = false } = {}) {
  const rows = Array.isArray(options) ? options : Object.entries(options || {});
  const items = rows.map(selectItem);

  if (includeBlank) {
    items.unshift(blankItem());
  } else if (items[0]?.value === "") {
    markPlaceholder(items[0]);
  }

  return nested ? nestItems(items) : items;
}

function selectItem(row) {
  const [title, value, attributes] = selectRow(row);
  const item = {
    title,
    value: value == null ? value : String(value),
    dataset: dataset(attributes?.data),
  };

  if (item.dataset.subtext) {
    item.subtitle = item.dataset.subtext;
  }

  return item;
}

// `"Option 1"` → `["Option 1", "Option 1"]`; `{ label, value }` or `{ name, value }` → `[label or name, value]`.
function selectRow(row) {
  if (Array.isArray(row)) {
    return row;
  }

  if (row !== null && typeof row === "object") {
    return [row.label ?? row.name, row.value];
  }

  return [row, row];
}

function blankItem() {
  return markPlaceholder({ title: " ", value: "", dataset: {} });
}

// A blank first row is the prompt: it is shown as a placeholder and is never the first result Enter commits.
function markPlaceholder(item) {
  item.placeholder = true;
  item.pendingChoice = false;

  return item;
}

// `{ category_description: "Heart", parent: 1 }` → `{ categoryDescription: "Heart", parent: "1" }`
function dataset(data = {}) {
  const entries = Object.entries(data).filter(([key, value]) => key && value != null);

  return Object.fromEntries(entries.map(([key, value]) => [datasetKey(key), datasetValue(value)]));
}

function datasetKey(key) {
  return String(key)
    .replaceAll("_", "-")
    .toLowerCase()
    .replace(/-([a-z])/g, (_, letter) => letter.toUpperCase());
}

function datasetValue(value) {
  return typeof value === "string" ? value : JSON.stringify(value);
}

function nestItems(items) {
  const byValue = new Map(items.map((item) => [item.value, item]));

  return items.filter((item) => {
    const parent = byValue.get(item.dataset.parent);

    if (!parent || parent === item) {
      return true;
    }

    parent.hasChildren = true;
    (parent.children ||= []).push(item);

    return false;
  });
}
